// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__DNV9M","empty":"ModalGraph_empty__2gAHz"};